export interface Announcement {
  id: string;
  message: string;
  audioUrl?: string;
  sentToFaculty: 'all' | string[];
  sentToParents: 'all' | string[];
  sentBy: {
    name: string;
    role: string;
    avatar: string;
  };
  createdAt: string;
  publishedAt: string;
  scheduledFor?: string;
  status: 'published' | 'scheduled' | 'draft';
  readBy: string[];
}

export const mockParents = [
  { id: 'par-001', name: 'Raj Mehta', email: 'raj.mehta@email.com', studentName: 'Aarav Mehta' },
  { id: 'par-002', name: 'Anita Sharma', email: 'anita.sharma@email.com', studentName: 'Priya Sharma' },
  { id: 'par-003', name: 'Wei Chen', email: 'wei.chen@email.com', studentName: 'Liam Chen' },
  { id: 'par-004', name: 'Maria Rodriguez', email: 'maria.r@email.com', studentName: 'Zara Rodriguez' },
  { id: 'par-005', name: 'Robert Williams', email: 'robert.w@email.com', studentName: 'Ethan Williams' },
  { id: 'par-006', name: 'Yuki Nakamura', email: 'yuki.n@email.com', studentName: 'Sofia Nakamura' },
  { id: 'par-007', name: 'Fatima Ayaan', email: 'fatima.a@email.com', studentName: 'Mohammed Ayaan' },
  { id: 'par-008', name: 'Deepak Kumar', email: 'deepak.k@email.com', studentName: 'Riya Kumar' },
  { id: 'par-009', name: 'Grace Osei', email: 'grace.o@email.com', studentName: 'Kwame Osei' },
  { id: 'par-010', name: 'Sunita Patel', email: 'sunita.p@email.com', studentName: 'Arjun Patel' },
  { id: 'par-011', name: 'Ahmed Hassan', email: 'ahmed.h@email.com', studentName: 'Layla Hassan' },
  { id: 'par-012', name: 'Linda Thompson', email: 'linda.t@email.com', studentName: 'Oliver Thompson' },
];

export const announcements: Announcement[] = [
  {
    id: 'ann-001',
    message: 'Dear Parents and Faculty, we are excited to announce the Annual Sports Day on August 15th. All students are encouraged to participate in the various events planned. Please ensure your child wears comfortable sports attire and carries a water bottle. The event will start at 9:00 AM sharp in the school ground.',
    sentToFaculty: 'all',
    sentToParents: 'all',
    sentBy: { name: 'Alexandra Reed', role: 'Admin', avatar: 'AR' },
    createdAt: '2026-07-30T08:00:00Z',
    publishedAt: '2026-07-30T08:00:00Z',
    status: 'published',
    readBy: ['Alexandra Reed', 'Sarah Mitchell'],
  },
  {
    id: 'ann-002',
    message: 'A gentle reminder that the Parent-Teacher Meeting for Pre-Primary and Primary sections is scheduled for August 5th, 2026 from 2:00 PM to 5:00 PM. Please book your time slots through the parent portal. Your involvement is crucial for your child\'s progress.',
    sentToFaculty: ['tch-001', 'tch-002', 'tch-003', 'tch-004', 'tch-007', 'tch-010', 'tch-011', 'tch-016'],
    sentToParents: ['par-001', 'par-002', 'par-003', 'par-004', 'par-006'],
    sentBy: { name: 'Sarah Mitchell', role: 'Coordinator', avatar: 'SM' },
    createdAt: '2026-07-29T14:30:00Z',
    publishedAt: '2026-07-29T14:30:00Z',
    status: 'published',
    readBy: [],
  },
  {
    id: 'ann-003',
    message: 'Attention all faculty members: The monthly staff meeting has been rescheduled to Wednesday, August 3rd at 3:30 PM in the Conference Hall. Agenda items include curriculum updates, upcoming events planning, and new therapy equipment orientation. Attendance is mandatory.',
    sentToFaculty: 'all',
    sentToParents: [],
    sentBy: { name: 'Alexandra Reed', role: 'Admin', avatar: 'AR' },
    createdAt: '2026-07-29T09:00:00Z',
    publishedAt: '2026-07-29T09:00:00Z',
    status: 'published',
    readBy: ['Alexandra Reed'],
  },
  {
    id: 'ann-004',
    message: 'We are pleased to inform you that the new Sensory Integration Room is now fully operational. This state-of-the-art facility includes a ball pit, swing system, tactile wall panels, and a calming corner. Therapists can now book sessions in this room through the scheduling portal. A training session for all therapists will be held this Friday at 11:00 AM.',
    sentToFaculty: 'all',
    sentToParents: 'all',
    sentBy: { name: 'Dr. Sarah Mitchell', role: 'Admin', avatar: 'SM' },
    createdAt: '2026-07-28T11:00:00Z',
    publishedAt: '2026-07-28T11:15:00Z',
    status: 'published',
    readBy: ['Alexandra Reed', 'Sarah Mitchell', 'Emma Reyes'],
  },
  {
    id: 'ann-005',
    message: 'Reminder: All individual education plans (IEPs) for the current quarter must be updated and submitted by August 10th. Please review progress goals and assessment data before submission. Late submissions will not be accepted without prior approval from the coordinator.',
    sentToFaculty: ['tch-001', 'tch-003', 'tch-004', 'tch-005', 'tch-008', 'tch-017'],
    sentToParents: [],
    sentBy: { name: 'Sarah Mitchell', role: 'Coordinator', avatar: 'SM' },
    createdAt: '2026-07-27T16:00:00Z',
    publishedAt: '2026-07-27T16:00:00Z',
    status: 'published',
    readBy: ['Alexandra Reed', 'Sarah Mitchell'],
  },
  {
    id: 'ann-006',
    message: 'Dear Parents, we are organizing a workshop on "Supporting Your Child\'s Emotional Regulation at Home" on August 12th from 10:00 AM to 12:00 PM. This workshop will be conducted by our clinical psychologist Dr. Sarah Mitchell. It is free of charge. Please register through the parent portal by August 8th.',
    sentToFaculty: [],
    sentToParents: 'all',
    sentBy: { name: 'Alexandra Reed', role: 'Admin', avatar: 'AR' },
    createdAt: '2026-07-30T07:30:00Z',
    publishedAt: '2026-07-30T07:30:00Z',
    status: 'published',
    readBy: [],
  },
  {
    id: 'ann-007',
    message: 'School will remain closed on August 20th on account of the local festival. All sessions and classes scheduled for that day are cancelled. Regular activities will resume on August 21st. Please plan accordingly.',
    sentToFaculty: 'all',
    sentToParents: 'all',
    sentBy: { name: 'Alexandra Reed', role: 'Admin', avatar: 'AR' },
    createdAt: '2026-07-30T10:00:00Z',
    publishedAt: '2026-07-30T10:00:00Z',
    scheduledFor: '2026-07-30T10:00:00Z',
    status: 'published',
    readBy: ['Alexandra Reed'],
  },
  {
    id: 'ann-008',
    message: 'We are introducing a new "Buddy Program" starting next week where older students will be paired with younger ones during group activities. This initiative aims to foster peer support, social skills development, and a sense of community. Teachers, please review your class pairings and provide feedback by tomorrow.',
    sentToFaculty: 'all',
    sentToParents: ['par-001', 'par-002', 'par-003', 'par-004', 'par-005', 'par-006'],
    sentBy: { name: 'Emma Reyes', role: 'Teacher', avatar: 'ER' },
    createdAt: '2026-07-29T13:00:00Z',
    publishedAt: '2026-07-29T13:00:00Z',
    status: 'published',
    readBy: [],
  },
  {
    id: 'ann-009',
    message: 'On August 2nd we will be conducting a full fire drill and emergency evacuation practice. All faculty members must review the updated evacuation routes posted in the staff room. Students should be briefed during morning circle time on August 1st. This is a mandatory safety exercise for everyone on campus.',
    audioUrl: 'https://example.com/audio/fire-drill.mp3',
    sentToFaculty: 'all',
    sentToParents: 'all',
    sentBy: { name: 'Alexandra Reed', role: 'Admin', avatar: 'AR' },
    createdAt: '2026-07-30T09:00:00Z',
    publishedAt: '2026-08-01T09:00:00Z',
    scheduledFor: '2026-08-01T09:00:00Z',
    status: 'scheduled',
    readBy: [],
  },
  {
    id: 'ann-010',
    message: 'The quarterly progress report cards will be distributed on August 8th. All therapists and teachers must finalise their assessment entries and goal-tracking data by August 5th at the latest. Please double-check that all domains are scored before submitting.',
    sentToFaculty: ['tch-001', 'tch-003', 'tch-005', 'tch-008', 'tch-017'],
    sentToParents: [],
    sentBy: { name: 'Sarah Mitchell', role: 'Coordinator', avatar: 'SM' },
    createdAt: '2026-07-30T08:30:00Z',
    publishedAt: '2026-08-03T08:30:00Z',
    scheduledFor: '2026-08-03T08:30:00Z',
    status: 'scheduled',
    readBy: [],
  },
  {
    id: 'ann-011',
    message: 'Dear Parents, please note that school photos will be taken on August 10th. Students should arrive in full school uniform. Individual and class group photos will be taken throughout the morning. Photo order forms were sent home last week — please return them by August 7th.',
    sentToFaculty: 'all',
    sentToParents: 'all',
    sentBy: { name: 'Alexandra Reed', role: 'Admin', avatar: 'AR' },
    createdAt: '2026-07-30T11:00:00Z',
    publishedAt: '2026-08-05T11:00:00Z',
    scheduledFor: '2026-08-05T11:00:00Z',
    status: 'scheduled',
    readBy: [],
  },
  {
    id: 'ann-012',
    message: 'We are thrilled to invite all parents to our Open House & Exhibition on August 18th from 4:00 PM to 7:00 PM. Students will showcase their artwork, therapy progress displays, and classroom projects. Light refreshments will be served. Please RSVP through the parent portal by August 14th.',
    sentToFaculty: 'all',
    sentToParents: 'all',
    sentBy: { name: 'Alexandra Reed', role: 'Admin', avatar: 'AR' },
    createdAt: '2026-07-30T06:00:00Z',
    publishedAt: '2026-08-12T06:00:00Z',
    scheduledFor: '2026-08-12T06:00:00Z',
    status: 'scheduled',
    readBy: [],
  },
];